import { ApiAmount } from "shared/types/ApiAmount";
import { PurchaseOrderLineAmounts } from "./types";
import { getFormattedCurrency } from "shared/utils";
import ApiPurchaseOrderLine from "shared/model/ApiPurchaseOrderLine";
import { ApiRateCardDiscountForUser } from "shared/types/ApiRateCardDiscountForUser";

function getAmountByKey(props: {
  purchaseOrderLine: ApiPurchaseOrderLine;
  key: keyof ApiRateCardDiscountForUser;
  fallbackKey: keyof ApiPurchaseOrderLine;
  localeId?: string;
}) {
  return props.purchaseOrderLine.discountForUser
    ? getFormattedCurrency(props.purchaseOrderLine.discountForUser?.[props.key] as ApiAmount, props.localeId)
    : getFormattedCurrency(props.purchaseOrderLine[props.fallbackKey] as ApiAmount, props.localeId);
}

function getDiscountByKey(props: {
  purchaseOrderLine: ApiPurchaseOrderLine;
  key: keyof ApiRateCardDiscountForUser;
  localeId?: string;
}) {
  return props.purchaseOrderLine.discountForUser
    ? getFormattedCurrency(props.purchaseOrderLine.discountForUser?.[props.key] as ApiAmount, props.localeId)
    : "";
}

export function getPurchaseOrderLinePriceForSummary(purchaseOrderLine: ApiPurchaseOrderLine, localeId?: string) {
  if (purchaseOrderLine.taxConfiguration.inclusive) {
    return getAmountByKey({
      purchaseOrderLine,
      key: "totalPriceWithoutDiscount",
      fallbackKey: "totalAmount",
      localeId
    });
  } else {
    return getAmountByKey({ purchaseOrderLine, key: "priceWithoutDiscount", fallbackKey: "lineAmount", localeId });
  }
}

export function getPurchaseOrderLineAmountsForDetails(
  purchaseOrderLine: ApiPurchaseOrderLine,
  localeId?: string
): PurchaseOrderLineAmounts {
  let poAmount = { price: "", tax: "", discount: "" };

  if (purchaseOrderLine.taxConfiguration.inclusive) {
    poAmount = {
      price: getAmountByKey({ purchaseOrderLine, key: "priceWithoutDiscount", fallbackKey: "lineAmount", localeId }),
      tax: getAmountByKey({ purchaseOrderLine, key: "taxWithoutDiscount", fallbackKey: "taxAmount", localeId }),
      discount: getDiscountByKey({ purchaseOrderLine, key: "discountAmount", localeId })
    };
  } else {
    poAmount = {
      price: getAmountByKey({ purchaseOrderLine, key: "priceWithoutDiscount", fallbackKey: "lineAmount", localeId }),
      tax: getAmountByKey({ purchaseOrderLine, key: "currentApplicableTax", fallbackKey: "taxAmount", localeId }),
      discount: getDiscountByKey({ purchaseOrderLine, key: "discountAmount", localeId })
    };
  }
  return poAmount;
}
